import SectionHeader from './SectionHeader.jsx';

const roles = [

  {
    title: 'Investors',
    glyph: 'investors',
  },

  {
    title: 'Land Owners',
    glyph: 'land',
  },
  {
    title: 'Developers',
    glyph: 'developers',
  },
  // {
  //   title: 'Brokers',
  // },
  {
    title: 'Channel Partners',
    glyph: 'partners',
  },
  
];

function CollaborateSection() {
  return (
    <section id="collab" data-section className="section-wrap fade-up">
      <div className="collab-redesign-wrap">

        <div className="collab-left">
          <SectionHeader
            label="Together"
            title="Collaborate with Trikon"
            subtitle="We work with each stakeholder in the outcome chain — because alignment of every mind makes projects succeed."
          />
        </div>

        <div className="collab-right">

          <div className="collab-role-list">
            {roles.map((role, index) => (
              <div key={index} className="collab-role-item">

                <div className="collab-role-left">
                  <span className="collab-role-glyph" aria-hidden="true">
                    <CollaborateGlyph glyph={role.glyph} />
                  </span>

                   <span className="collab-role-title">
                    {role.title}
                  </span>

                  <span className="collab-role-arrow">
                    &rarr;
                  </span>

                 
                </div>

              </div>
            ))}
          </div>

        </div>
      </div>

      <style jsx>{`
        .collab-redesign-wrap {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 70px;
          align-items: flex-start;
        }

        .collab-right {
          width: 100%;
        }

        .collab-role-list {
          width: 100%;
          border-top: 1px solid rgba(255,255,255,0.14);
        }

        .collab-role-item {
          border-bottom: 1px solid rgba(255,255,255,0.14);
          padding: 10px;
          cursor: pointer;
          transition: all 0.35s ease;
        }

        .collab-role-left {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .collab-role-glyph {
          width: 48px;
          height: 48px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          color: #00d4c8;
          border: 1px solid rgba(0, 212, 200, 0.18);
          border-radius: 14px;
          background: rgba(0, 212, 200, 0.06);
          box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.03);
          transition: border-color 0.35s ease, box-shadow 0.35s ease, background 0.35s ease, color 0.35s ease;
        }

        .collab-role-glyph svg {
          width: 28px;
          height: 28px;
          stroke: currentColor;
          stroke-width: 1.7;
          fill: none;
          stroke-linecap: round;
          stroke-linejoin: round;
        }

        .collab-role-item:hover .collab-role-glyph {
          color: #ffffff;
          border-color: rgba(0, 212, 200, 0.42);
          background: rgba(0, 212, 200, 0.1);
          box-shadow: 0 0 0 1px rgba(0, 212, 200, 0.08), 0 10px 24px rgba(0, 212, 200, 0.12);
        }

        .collab-role-title {
          font-size: 30.2px;
          font-weight: 700;
          // color: #ffffff;
          color: #00d4c8;
          transition: all 0.35s ease;
          letter-spacing: -0.4px;
          margin-bottom: 0;
        }

        .collab-role-arrow {
          font-size: 18px;
          color: #fff;
          
          opacity: 0;
          transform: translateX(-10px);
          transition: all 0.35s ease;
        }

        .collab-role-item:hover .collab-role-arrow {
          opacity: 1;
          transform: translateX(0);
        }



        .collab-role-item:hover .collab-role-title {
          
          color: #ffffff;
          transform: translateX(4px);
        }

        .collab-role-item:hover {
          border-bottom-color: rgba(0, 212, 200, 0.45);
        }

        @media (max-width: 991px) {
          .collab-redesign-wrap {
            grid-template-columns: 1fr;
            gap: 50px;
          }

          .collab-role-title {
            font-size: 18px;
          }

          .collab-role-item {
            padding: 14px 0;
          }

          .collab-role-glyph {
            width: 42px;
            height: 42px;
            border-radius: 12px;
          }

          .collab-role-glyph svg {
            width: 24px;
            height: 24px;
          }
        }
      `}</style>
    </section>
  );
}

function CollaborateGlyph({ glyph }) {
  switch (glyph) {
    
case 'investors':
  return (
    <svg viewBox="0 0 28 28" focusable="false">
      <path d="M14 5v18" />
      <path d="M18 9.5c0-1.8-1.8-3-4-3s-4 1.2-4 3 1.5 2.7 4 3 4 1.2 4 3-1.8 3-4 3-4-1.2-4-3" />
      <path d="M22 14a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z" />
    </svg>
  );

     case 'land':
  return (
    <svg viewBox="0 0 28 28" focusable="false">
      <path d="M5 20l6-6 4 3 8-8" />
      <path d="M18 9h5v5" />
      <path d="M7 23h14" />
      <path d="M7 23V11" />
      <path d="M14 23v-6" />
      <path d="M21 23v-9" />
      <path d="M14 6c-2 0-3.5 1.5-3.5 3.3 0 2.8 3.5 6.2 3.5 6.2s3.5-3.4 3.5-6.2C17.5 7.5 16 6 14 6Z" />
      <circle cx="14" cy="9.3" r="1.2" />
    </svg>
  );
   
      case 'developers':
  return (
    <svg viewBox="0 0 28 28" focusable="false">
      <path d="M6 23V8l8-3 8 3v15" />
      <path d="M10 11h2" />
      <path d="M16 11h2" />
      <path d="M10 15h2" />
      <path d="M16 15h2" />
      <path d="M12 23v-4h4v4" />
    </svg>
  );

  case 'partners':
  return (
    <svg viewBox="0 0 28 28" focusable="false">
      <circle cx="8" cy="8" r="2.2" />
      <circle cx="20" cy="8" r="2.2" />
      <circle cx="14" cy="20" r="2.2" />

      <path d="M10 9.5l2.8 7" />
      <path d="M18 9.5l-2.8 7" />
      <path d="M10.5 8h7" />
    </svg>
  );

    default:
      return null;
  }
}

export default CollaborateSection;


// import SectionHeader from './SectionHeader.jsx';
// import { useState } from 'react';

// const roles = [
//   {
//     icon: '\u{1F331}',
//     title: 'Land Owners',
//     text: 'Unlock the potential of your land through market intelligence, strategic positioning and best-fit developer partnerships.',
//   },
//   {
//     icon: '\u{1F3D7}\uFE0F',
//     title: 'Developers',
//     text: 'Execute smarter with architecture-led briefs, demand-backed product strategy and structured capital partnerships.',
//   },
//   {
//     icon: '\u{1F4BC}',
//     title: 'Brokers',
//     text: 'Partner with Trikon to access exclusive projects and structured collaboration models that generate real value.',
//   },
//   {
//     icon: '\u{1F4C8}',
//     title: 'Channel Partners',
//     text: 'Grow your network inside the Trikon ecosystem - access curated investment and partnership opportunities.',
//   },
//   {
//     icon: '\u{1F4C8}',
//     title: 'Investors',
//     text: 'Deploy capital into curated, high-potential opportunities with transparent structures and clear timelines.',
//   },
// ];

// function CollaborateSection() {
//   const [selectedRole, setSelectedRole] = useState(roles[0]);
//   const [isOpen, setIsOpen] = useState(false);

//   return (
//     <section id="collab" data-section className="section-wrap fade-up">
//       <div className="collab-redesign-wrap">
//         <div className="collab-left">
//           <SectionHeader
//             label="Together"
//             title="Collaborate with Trikon"
//             subtitle="We work with each stakeholder in the outcome chain - because alignment of every mind makes projects succeed."
//           />
//         </div>

//         <div className="collab-right">
//           <div className="collab-dropdown-wrap">
//             <label className="collab-dropdown-label">Select Your Role</label>
//             <div className="collab-dropdown">
//               <button 
//                 className="collab-dropdown-trigger"
//                 onClick={() => setIsOpen(!isOpen)}
//               >
//                 <span className="collab-dropdown-icon">{selectedRole.icon}</span>
//                 <span className="collab-dropdown-text">{selectedRole.title}</span>
//                 <span className={`collab-dropdown-chevron ${isOpen ? 'open' : ''}`}>▼</span>
//               </button>

//               {isOpen && (
//                 <div className="collab-dropdown-menu">
//                   {roles.map((role) => (
//                     <button
//                       key={role.title}
//                       className={`collab-dropdown-item ${selectedRole.title === role.title ? 'active' : ''}`}
//                       onClick={() => {
//                         setSelectedRole(role);
//                         setIsOpen(false);
//                       }}
//                     >
//                       <span className="collab-dropdown-item-icon">{role.icon}</span>
//                       <span>{role.title}</span>
//                     </button>
//                   ))}
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

// export default CollaborateSection;


// 5cards and circle ui

// import SectionHeader from './SectionHeader.jsx';

// const collaborators = [
//   {
//     title: 'Developers',
//     short: 'DEV',
//     icon: '🛠️',
//     x: '50%',
//     y: '8%',
//     text: 'Design-led development, faster approvals and value-focused execution.',
//   },
//   {
//     title: 'Land Owners',
//     short: 'LAND',
//     icon: '🌱',
//     x: '18%',
//     y: '42%',
//     text: 'Unlock land value through strategic planning, permissions and market fit.',
//   },
//   {
//     title: 'Brokers',
//     short: 'BROKER',
//     icon: '🤝',
//     x: '82%',
//     y: '42%',
//     text: 'Access curated opportunities and structured collaboration for premium clients.',
//   },
//   {
//     title: 'Investors',
//     short: 'INVEST',
//     icon: '💼',
//     x: '35%',
//     y: '78%',
//     text: 'Deploy capital with clarity via transparent project metrics and insight.',
//   },
//   {
//     title: 'Channel Partners',
//     short: 'CHANNEL',
//     icon: '🌐',
//     x: '65%',
//     y: '78%',
//     text: 'Grow your pipeline with co-branded access to Trikon’s benchmarked deals.',
//   },
// ];

// function CollaborateSection() {
//   return (
//     <section
//       id="collab"
//       data-section
//       className="collab-section fade-up"
//     >

//       {/* BACKGROUND */}
//       <div className="collab-grid-bg" />
//       <div className="collab-noise" />

//       <div className="collab-glow glow-1" />
//       <div className="collab-glow glow-2" />

//       <SectionHeader
//         label="Ecosystem"
//         title="Collaborate with Trikon"
//         subtitle="A connected network of land, capital, intelligence and execution."
//          centered={true}
       
//       />

//       <div className="ecosystem-mobile-title">
//         Discover how each partner contributes to Trikon’s connected ecosystem.
//       </div>

//       <div className="ecosystem-wrap">

//         {/* CENTER CORE */}
//         <div className="trikon-core">

//           <div className="core-ring ring-1" />
//           <div className="core-ring ring-2" />
//           <div className="core-ring ring-3" />

//           <div className="core-content">
//             <h2>TRIKON</h2>
//             <p>ECOSYSTEM CORE</p>
//           </div>
//         </div>

//         {/* CONNECTIONS */}
//         <svg
//           className="ecosystem-lines"
//           viewBox="0 0 1200 800"
//           preserveAspectRatio="none"
//         >
//           <line x1="600" y1="390" x2="600" y2="130" />
//           <line x1="600" y1="390" x2="250" y2="340" />
//           <line x1="600" y1="390" x2="950" y2="340" />
//           <line x1="600" y1="390" x2="430" y2="620" />
//           <line x1="600" y1="390" x2="770" y2="620" />
//         </svg>

//         {/* NODES */}
//         {collaborators.map((item) => (
//           <div
//             key={item.title}
//             className="ecosystem-node"
//             style={{
//               left: item.x,
//               top: item.y,
//             }}
//           >
//             <div className="node-glow" />
//             <div className="node-inner">
//               <div className="node-head">
//                 <div className="node-chip">{item.short}</div>
//                 <div className="node-icon">{item.icon}</div>
//               </div>
//               <h3>{item.title}</h3>
//               <p>{item.text}</p>
//             </div>
//           </div>
//         ))}
//       </div>

//       <div className="collab-cta">
//         <a href="#contact" className="ecosystem-btn">
//           Join The Ecosystem
//         </a>
//       </div>

//       <style>{`

//         .collab-section{
//           position:relative;
//           overflow:hidden;
//           padding:140px 70px;
//           background: radial-gradient(circle at top left, rgba(0,212,200,.08), transparent 22%), radial-gradient(circle at bottom right, rgba(0,120,255,.08), transparent 26%), linear-gradient(180deg, #020b14 0%, #040f1d 100%);
//         }

//         /* =========================
//            BACKGROUND
//         ========================= */

//         .collab-grid-bg{
//           position:absolute;
//           inset:0;

//           background-image:
//             linear-gradient(rgba(0,212,200,.02) 1px, transparent 1px),
//             linear-gradient(90deg, rgba(0,212,200,.02) 1px, transparent 1px);

//           background-size:110px 110px;

//           opacity:.18;
//           pointer-events:none;
//         }

//         .collab-noise{
//           position:absolute;
//           inset:0;

//           opacity:.04;

//           background-image:
//             radial-gradient(circle at 18% 18%, rgba(255,255,255,.42) 1px, transparent 1px),
//             radial-gradient(circle at 80% 22%, rgba(0,212,200,.18) 1px, transparent 1px);

//           background-size:28px 28px;

//           pointer-events:none;
//         }

//         .collab-glow{
//           position:absolute;
//           border-radius:50%;
//           filter:blur(120px);
//           pointer-events:none;
//           opacity:.85;
//         }

//         .glow-1{
//           width:420px;
//           height:420px;
//           background:rgba(0,212,200,.10);
//           top:-180px;
//           left:-140px;
//         }

//         .glow-2{
//           width:360px;
//           height:360px;
//           background:rgba(0,120,255,.10);
//           right:-100px;
//           bottom:-120px;
//         }

//         /* =========================
//            WRAP
//         ========================= */

//         .ecosystem-wrap{
//           position:relative;
//           width:100%;
//           max-width:1200px;
//           height:760px;
//           margin:100px auto 0;
//         }

//         /* =========================
//            CENTER CORE
//         ========================= */

//         .trikon-core{
//           position:absolute;
//           left:50%;
//           top:44%;
//           transform:translate(-50%,-50%);

//           width:340px;
//           height:220px;

//           display:flex;
//           align-items:center;
//           justify-content:center;
//         }

//         .core-ring{
//           position:absolute;
//           border-radius:50%;
//           border:1px solid rgba(0,212,200,.14);
//           box-shadow: 0 0 40px rgba(0,212,200,.05);
//         }

//         .ring-1{
//           width:320px;
//           height:320px;
//           opacity:.9;
//           animation:rotateSlow 22s linear infinite;
//         }

//         .ring-2{
//           width:450px;
//           height:450px;

//           border-style:dotted;
//           opacity:.48;

//           animation:rotateSlowReverse 30s linear infinite;
//         }

//         .ring-3{
//           width:580px;
//           height:580px;
//           opacity:.14;
//         }

//         .core-content{
//           width:210px;
//           height:210px;
//           padding: 24px;

//           border-radius:50%;

//           background:
//             radial-gradient(
//               circle at top,
//               rgba(0,212,200,.22),
//               rgba(5,16,30,.95)
//             );

//           border:1px solid rgba(0,212,200,.18);

//           backdrop-filter:blur(20px);

//           display:flex;
//           flex-direction:column;
//           align-items:center;
//           justify-content:center;

//           box-shadow:
//             0 0 60px rgba(0,212,200,.12),
//             inset 0 0 40px rgba(0,212,200,.08);
//         }

//         .core-content h2{
//           font-size:30px;
//           letter-spacing:3px;
//           color:#fff;
//           margin-bottom:10px;
//           font-weight:800;
//           line-height:1.1;
//         }

//         .core-content p{
//           font-size:11px;
//           letter-spacing:3px;
//           color:var(--cyan);
//         }

//         /* =========================
//            LINES
//         ========================= */

//         .ecosystem-lines{
//           position:absolute;
//           inset:0;
//           width:100%;
//           height:100%;
//           overflow:visible;
//         }

//         .ecosystem-lines line{
//           stroke:rgba(0,212,200,.18);
//           stroke-width:1.5;
//           stroke-dasharray:6 10;

//           filter:
//             drop-shadow(0 0 10px rgba(0,212,200,.18));
//         }

//         /* =========================
//            NODES
//         ========================= */

//         .ecosystem-node{
//           position:absolute;
//           transform:translate(-50%,-50%);
//           width:280px;
//           min-height:220px;
//           display:grid;
//           place-items:center;
//           transition:.45s ease;
//         }

//         .ecosystem-node:hover{
//           transform:translate(-50%,-50%) scale(1.035);
//         }

//         .node-glow{
//           position:absolute;
//           inset:-6px;

//           border-radius:30px;

//           background:
//             linear-gradient(
//               135deg,
//               rgba(0,212,200,.22),
//               transparent 72%
//             );

//           opacity:.48;

//           transition:.4s ease;
//         }

//         .ecosystem-node:hover .node-glow{
//           opacity:.82;
//         }

//         .node-inner{
//           position:relative;
//           width:100%;
//           min-height:220px;
//           padding:26px 24px 24px;
//           display:grid;
//           gap:18px;
//           background:
//             linear-gradient(
//               180deg,
//               rgba(5,16,30,.92),
//               rgba(2,10,20,.96)
//             );
//           border:1px solid rgba(0,212,200,.14);
//           border-radius:36px;
//           backdrop-filter:blur(22px);
//           overflow:hidden;
//           box-shadow:
//             inset 0 1px 0 rgba(255,255,255,.05),
//             0 32px 64px rgba(0,0,0,.28);
//           transition:.4s ease;
//         }

//         .ecosystem-node:hover .node-inner{
//           box-shadow:
//             inset 0 1px 0 rgba(255,255,255,.08),
//             0 40px 84px rgba(0,0,0,.42),
//             0 0 40px rgba(0,212,200,.12);
//         }

//         .node-inner::before{
//           content:'';
//           position:absolute;
//           top:18px;
//           right:18px;
//           width:60px;
//           height:60px;
//           border-radius:50%;
//           background: rgba(0,212,200,.08);
//           filter: blur(10px);
//           pointer-events:none;
//         }

//         .node-head{
//           display:flex;
//           align-items:center;
//           justify-content:space-between;
//           gap:12px;
//           z-index:1;
//         }

//         .node-chip{
//           padding:8px 12px;
//           border-radius:999px;
//           border:1px solid rgba(0,212,200,.25);
//           background: rgba(0,212,200,.08);
//           color: var(--cyan);
//           font-size:11px;
//           letter-spacing:2px;
//           text-transform:uppercase;
//           font-weight:700;
//         }

//         .node-icon{
//           width:42px;
//           height:42px;
//           display:flex;
//           align-items:center;
//           justify-content:center;
//           border-radius:16px;
//           background: rgba(255,255,255,.06);
//           color: rgba(255,255,255,.95);
//           font-size:18px;
//           box-shadow: inset 0 0 0 1px rgba(255,255,255,.05);
//         }

//         .node-inner h3{
//           font-size:28px;
//           line-height:1.1;
//           color:#fff;
//           margin:0;
//           letter-spacing:-1px;
//           font-weight:800;
//           z-index:1;
//         }

//         .node-inner p{
//           color: rgba(255,255,255,.75);
//           font-size:14px;
//           line-height:1.75;
//           margin:0;
//           z-index:1;
//         }

//         /* =========================
//            BUTTON
//         ========================= */

//         .collab-cta{
//           display:flex;
//           justify-content:center;

//           margin-top:42px;
//         }

//         .ecosystem-mobile-title{
//           display:none;
//           max-width:700px;
//           margin:0 auto;
//           color: rgba(255, 255, 255, .75);
//           font-size: 15px;
//           line-height: 1.8;
//           text-align: center;
//           letter-spacing: .01em;
//           padding: 0 14px;
//         }

//         .ecosystem-btn{
//           display:inline-flex;
//           align-items:center;
//           justify-content:center;

//           padding:18px 38px;

//           background:linear-gradient(135deg, rgba(0,212,200,.12), rgba(0,120,255,.18));
//           border:1px solid rgba(0,212,200,.22);
//           border-radius:999px;

//           color:#fff;
//           text-decoration:none;
//           letter-spacing:1px;
//           font-weight:700;
//           backdrop-filter:blur(16px);
//           box-shadow: 0 0 0 rgba(0,212,200,0);

//           transition:.35s ease, transform .35s ease;
//         }

//         .ecosystem-btn:hover{
//           transform:translateY(-4px);

//           background:linear-gradient(135deg, rgba(0,212,200,.18), rgba(0,120,255,.24));

//           box-shadow:
//             0 18px 38px rgba(0,212,200,.16),
//             0 0 20px rgba(0,212,200,.08);
//         }

//         /* =========================
//            ANIMATION
//         ========================= */

//         @keyframes rotateSlow{

//           from{
//             transform:rotate(0deg);
//           }

//           to{
//             transform:rotate(360deg);
//           }
//         }

//         @keyframes rotateSlowReverse{

//           from{
//             transform:rotate(360deg);
//           }

//           to{
//             transform:rotate(0deg);
//           }
//         }

//         /* =========================
//            MOBILE
//         ========================= */

//         @media(max-width:1100px){

//           .collab-section{
//             padding:80px 20px 42px;
//           }

//           .collab-section .section-sub {
//            margin-bottom: 50px !important;
//       }

//           .collab-section .section-sub{
//             margin-bottom:18px;
//           }

//           .ecosystem-mobile-title{
//             display:block;
//             margin-bottom:10px;
            
//           }

//           .ecosystem-wrap{
//             width:100%;
//             height:auto;
//             display:flex;
//             flex-direction:column;
//             align-items:center;
//             gap:22px;
//             padding-bottom:20px;
//           }

//           .ecosystem-lines{
//             display:none;
//           }

//           .trikon-core{
//             display:none;
//           }

//           .ecosystem-node{
//             position:relative;
//             left:auto !important;
//             top:auto !important;
//             transform:none;
//             width:100%;
//             max-width:480px;
//             min-height:auto;
//           }

//           .ecosystem-node:hover{
//             transform:translateY(-4px);
//           }

//           .ring-3{
//             display:none;
//           }
//         }

//         @media(max-width:640px){

//           .collab-section{
//             padding:90px 20px;
//           }

//           .trikon-core{
//             width:220px;
//             height:220px;
//           }

//           .ring-1{
//             width:220px;
//             height:220px;
//           }

//           .ring-2{
//             width:300px;
//             height:300px;
//           }

//           .core-content{
//             width:170px;
//             height:170px;
//             border-radius:50%;
//           }

//           .core-content h2{
//             font-size:26px;
//           }

//           .node-inner{
//             padding:24px 22px;
//           }

//           .node-inner h3{
//             font-size:26px;
//           }

//           .node-inner p{
//             font-size:14px;
//           }
//         }

//       `}</style>
//     </section>
//   );
// }

// export default CollaborateSection;
